import React from 'react';
import { C, FadeUp, Kicker, SectionH2, SectionSub, SECTION_PAD, useSectionView, track } from './shared';
import GrowthStrategyPreview from '../GrowthStrategyPreview';

export const ScannerSection = () => {
  const ref = useSectionView('scanner');
  return (
    <section id="scanner" ref={ref} style={{ padding: SECTION_PAD }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <FadeUp><Kicker center>Start with your actual business</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2 center>
            ScalitOS understands your business<br />before it gives you advice.
          </SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <SectionSub center style={{ marginBottom: 44 }}>
            Drop your website URL. ScalitOS studies your brand, spots your biggest growth gap, and recommends your next campaign with a 7-day plan. Create a free account to unlock the full strategy.
          </SectionSub>
        </FadeUp>
        <FadeUp delay={200}>
          <div onClickCapture={() => track('scanner_interacted')}>
            <GrowthStrategyPreview defaultUrl="" />
          </div>
        </FadeUp>
        <FadeUp delay={260}>
          <p style={{ marginTop: 24, textAlign: 'center', fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, color: C.muted }}>
            We only read what is publicly visible on the URL you enter. You can edit everything afterwards.
          </p>
        </FadeUp>
      </div>
    </section>
  );
};
